export function DashboardTopBrandsHeader() {
  return (
    <div className="mb-1 d-none d-sm-flex align-items-center gap-3 px-3 fs--2 fw-medium text-500">
      <span className="flex-shrink-0 text-center" style={{ width: '1.75rem' }}>#</span>
      <span className="flex-grow-1 min-w-0">برند</span>
      <div className="d-flex flex-shrink-0 align-items-center gap-4 gap-sm-5">
        <span className="flex-shrink-0 text-center" style={{ width: '4.5rem' }}>دیده‌شدن در AI</span>
        <span className="flex-shrink-0 text-center" style={{ width: '4rem' }}>استفاده در AI</span>
        <span className="flex-shrink-0 text-center" style={{ width: '3.5rem' }}>منشن</span>
        <span className="flex-shrink-0 text-center" style={{ width: '4.5rem' }}>میانگین رتبه</span>
        <span className="flex-shrink-0 text-center" style={{ width: '4.5rem' }}>ترند</span>
      </div>
    </div>
  );
}
